import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StockCategoryModel } from '../model/stock-category.model';
import { StockCategoryService } from '../../../stock-category/stock-category.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DepartmentService } from 'src/app/pages/common/system/department/department.service';

@Component({
  selector: 'app-stock-category-edit',
  templateUrl: './stock-category-edit.component.html',
  styleUrls: ['./stock-category-edit.component.scss'],
  standalone: false
})
export class StockCategoryEditComponent implements OnInit {
  title: string = 'New Stock Category';
  editForm: FormGroup;
  stockCategoryInfo: StockCategoryModel = {};
  isFormDirty: boolean = false;
  stock_item_category_id: any;
  selectedCategory: any;
  departmentList: any;
  superCategoryList: any;
  isSubCategory: boolean = false;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private departmentService: DepartmentService,
    private categoryService: StockCategoryService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog
  ) {
    const categoryId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: ['', [Validators.required, Validators.maxLength(10)]],
      name: ['', [Validators.required, Validators.maxLength(50)]],
      department_id: [null],
      super_category_id: [null]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (categoryId && parseInt(categoryId) !== 0) {
      this.setStockCategoryInfo(categoryId);
    }
  }

  ngOnInit(): void {
    this.loadDepartmentList();
    this.loadCategoryList();
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/product/stock-category']);
  }
  onCategoryChange(categoryId: any): void {
    let category = this.superCategoryList.find((cat: any) => (cat.id == categoryId));
    if (category != undefined) {
      let department = this.departmentList.find((dept: any) => (dept.id == category.department_id));
      if (department != undefined) {
        this.editForm.patchValue({
          department_id: department.id

        });

      }
    }
  }

  setStockCategoryInfo(categoryId: any): void {
    this.categoryService.getById(categoryId).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          this.stockCategoryInfo = response.data.category;
          this.editForm.patchValue(this.stockCategoryInfo);
          this.title = this.getTitle();
          this.isFormDirty = false;
          this.isSubCategory = (this.stockCategoryInfo.super_category_id != undefined && this.stockCategoryInfo.super_category_id != 0)
        } else {
          this.showErrorSnackbar(response.message);
        }
      },
      error: () => {
        this.showErrorSnackbar('Failed to get data from server. Connection to the server failed.');
      }
    });
  }

  getTitle(): string {
    return this.stockCategoryInfo.id === 0
      ? 'New Stock Category Item'
      : `Editing: ${this.stockCategoryInfo.name}`;
  }

  loadDepartmentList(): void {
    const requestData = {
      search: {
        filters: { column: [], scope: { limit: 100, offset: 0 } },
        sort: [{ column: 'code', order: 'asc' }]
      }
    };

    this.departmentService.getDepartmentList(requestData).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          this.departmentList = response.data.departments;
        } else {
          this.showErrorSnackbar(response.message);
        }
      },
      error: () => {
        this.showErrorSnackbar('Failed to load departments.');
      }
    });
  }

  loadCategoryList(): void {
    const requestData = {
      search: {
        filters: { column: [], scope: { limit: 100, offset: 0 } },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };

    this.categoryService.getParentCategory(requestData).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          this.superCategoryList = response.data.categories;
        } else {
          this.showErrorSnackbar(response.message);
        }
      },
      error: () => {
        this.showErrorSnackbar('Failed to load categories.');
      }
    });
  }

  toggleCategoryDropdown(): void {
    this.isSubCategory = !this.isSubCategory;



    this.isFormDirty = true;


  }
  onDepartmentChange(): void {
    this.editForm.get('super_category_id')?.setValue(null);
  }


  save(): void {
    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      // If unchecked (false), set super_category_id to null
      if (!this.isSubCategory) {
        this.editForm.get('super_category_id')?.setValue(null);
      }
      Object.assign(this.stockCategoryInfo, this.editForm.value);

      this.categoryService.update(this.stockCategoryInfo).subscribe({
        next: (response) => {
          if (response.status === 'SUCCESS') {
            this.isFormDirty = false;
            this.showSuccessSnackbar(
              `The record for ${this.stockCategoryInfo.name} has been updated successfully.`
            );
            this.router.navigate(['/product/stock-category']);
          } else {
            this.showErrorSnackbar(response.message);
          }
        },
        error: () => {
          this.showErrorSnackbar('Failed to update. Connection to the server failed.');
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }

  private showErrorSnackbar(message: string): void {
    const snackBarData: SnackBarData = {
      message,
      title: 'Failed!!!',
      type: 'error'
    };
    this.snackBarService.openSnackBar(snackBarData);
  }

  private showSuccessSnackbar(message: string): void {
    const snackBarData: SnackBarData = {
      message,
      title: 'Success',
      type: 'success'
    };
    this.snackBarService.openSnackBar(snackBarData);
  }
}
